import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import {
  Curve,
  NewBackButton,
  NoticeIcon,
  TrophyIcon,
} from "../../../../components/svgs";
import { CurveHolder, StyledText } from "../../../../components/common/basic";

// theme
import { useTheme } from "../../../../hooks";

import { Desktop } from "../../../../containers/common";


const formatISODate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() < 12 ? "am" : "pm";
  const formattedDate = `${day}.${month}.${year} | ${hours}:${minutes}${ampm}`;
  return formattedDate;
};

const History = ({ background, data, getItemFromStock }) => {

  return (
    <div style={{ width: "90%", margin: "20px auto", padding: "10px", borderTop: "1px solid #ddd" }}>
      <StyledText size={20}>History</StyledText>
      <HistoryContainer>
        {data?.map((item) => (
          <div
            style={{
              width: "100%",
              backgroundColor: "white",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              height: 65,
              borderRadius: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              //   marginTop:15,
              marginBottom: 15,
            }}
          >
            <div
              style={{
                backgroundColor: background,
                width: "15%",
                height: 65,
                borderBottomLeftRadius: 15,
                display: "flex",
                borderTopLeftRadius: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {item.won ? <TrophyIcon /> : <NoticeIcon />}
            </div>

            <div
              style={{
                width: "80%",
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              <StyledText size={12} style={{ fontFamily: "MTNRegular" }}>
                You played <span style={{ fontFamily: "MTNBold" }}>Spin The Wheel</span>
                {item.won ? (
                  <span style={{ fontFamily: "MTNRegular" }}>
                    {" "}
                    and won{" "}
                    <span style={{ fontFamily: "MTNBold" }}>{getItemFromStock(item?.itemCode)?.name}</span>
                  </span>
                ) : (
                  ""
                )}
              </StyledText>
              <StyledText
                style={{
                  fontSize: 10,
                  color: "#7F7F7F",
                  marginTop: -5,
                }}
              >{`Played on ${formatISODate(
                item.createdAt
              )}`}</StyledText>
            </div>
          </div>
        ))}
      </HistoryContainer>
    </div>
  );
};

const HistoryContainer = styled.div`
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 15px;
  overflow: auto;
`;

export default History;
